
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Kiinnitä',
	'find_label': 'Etsi',
	'findCancelLabel': 'Peruuta',
	'dataPaneLabel': 'Tiedot',
	'sourcePaneLabel': 'Valitut lähteet',
	'sourcePaneContentLabel': 'Valitse lähde',
	'emptySourcePaneTitle': 'Valitse lähde',
	'emptySourcePaneCaption': 'Lisää mittatietotaulun luontiin käytettävä tiedot valitsemalla Valitse lähde.',
	'addDataSource': 'Valitse lähde',
	'addDataDashboardCoachMarkContents': 'Vedä ja pudota tietoja tietonäytöstä mittatietotauluun.',
	'addDataStoryCoachMarkContents': 'Vedä ja pudota tietoja tietonäytöstä tarinaan.',
	'addDataCoachMarkTitle': 'Lisää tietoja',
	'selectSourcesText': 'Luo %{app} valitsemalla ja lisäämällä tietolähde.',
	'selectSourcesLabel': 'Valitse lähde',
	'errorSourcesTitle': 'Tietorakenteen lataus epäonnistui',
	'errorLoadingDataSources': 'Tietojoukkojen luetteloa ladattaessa on ilmennyt virhe',
	'errorLoadingDataTree': 'Rakenne-esitystä ladattaessa on ilmennyt virhe',
	'dataSetPaneLastUpdated': 'Päivitetty viimeksi: %{date}',
	'dataSourcePaneDateUnknown': 'Tuntematon',
	'moreTitle': 'Enemmän',
	'backLabel': 'Takaisin',
	'addDataSourceDialogTitle': 'Valitse lähde',
	'addDataSourceDialogButtonLabel': 'Lisää',
	'dlg_use': 'Käytä',
	'dlg_RelinkDataSourceTitle': 'Korvaa tietojoukko %{dataSourceName} kohteella...',
	'propertiesDialogTitle': 'Ominaisuudet',
	'loadingMetadata': 'Metatietojen lataus',
	'missingDataSetData': 'Tämän tietojoukon tiedot eivät ole käytettävissä. Päivitä tietojoukko, tai pyydä pääkäyttäjältä lähteen käyttöoikeus.',
	'errorLoadingSource': 'Lähteen %{sourceName} metatiedot eivät latautuneet. Lisätietoja saat pääkäyttäjältä.',
	'errorMessageTitle': 'Virhe',
	'calculation_navigation_in_use': 'Jos laskelmat, suodattimet ja siirtymistoiminnot poistetaan, kaikki poistettuun objektiin viittaavat visualisoinnit muuttuvat virheellisiksi. Haluatko varmasti poistaa kohteen?',
	'delete_confirm': 'Vahvista poisto',
	'previewUnavailable': 'Tietovalikoima ja yleissuodattimet eivät ole käytettävissä tätä pakettia varten.',
	'contextualGridTabName': 'Visualisoinnin tiedot',
	'DATA_TRAY_no_data_text': 'Sinulla ei ole tällä hetkellä tietoja.',
	'contextualGridMenuLabel': 'Visualisoinnin tietojen valikko',
	'contextualGridExport': 'Vienti',
	'nullValueText': 'Tyhjä',
	'forecastDetailsTabName': 'Tilastollisen ennusteen tiedot',
	'forecastDetailsModelLabel': 'Malli',
	'forecastDetailsQualityMetricLabel': 'Tarkkuuslukuarvot',
	'forecastDetailsSmoothingCoefLabel': 'Parametrit',
	'forecastDetailsDiagnostics': 'Vianmääritys',
	'forecastDetailsForecastLabel': 'Ennuste',
	'forecastDetailsStatusLabel': 'Tila',
	'forecastDetailsAccuracyPercentLabel': 'Tarkkuusprosentti',
	'forecastDetailsTrendLabel': 'Suuntaus',
	'forecastDetailsSeasonLabel': 'Kausittaisuus',
	'forecastDetailsSeasonalPeriodLabel': 'Kausittainen ajanjakso',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beeta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Fii',
	'forecastDetailsMissingCount': 'Puuttuva määrä',
	'forecastDetailsSeriesLengthLabel': 'Sarjan pituus',
	'forecastDetailsIgnoredPeriods': 'Ohitettavat jaksot',
	'forecastDetailsTrendStrength': 'Suuntauksen vahvuus',
	'forecastDetailsSeasonalityStrength': 'Kausittaisuuden vahvuus',
	'forecastDetailsTimeDeltaUnit': 'Päivämäärä-/aikaväli',
	'forecastDetailsNotes': 'Huomautukset'
});
